// Mock Bible data for initial frontend development
export const mockBibleVerses = [
  {
    id: '1',
    book: 'John',
    chapter: 3,
    verse: 16,
    text: 'For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life.',
    translation: 'KJV'
  },
  {
    id: '2',
    book: 'Psalm',
    chapter: 23,
    verse: 1,
    text: 'The LORD is my shepherd; I shall not want.',
    translation: 'KJV'
  },
  {
    id: '3',
    book: 'Proverbs',
    chapter: 3,
    verse: 5,
    text: 'Trust in the LORD with all thine heart; and lean not unto thine own understanding.',
    translation: 'KJV'
  },
  {
    id: '4',
    book: 'Romans',
    chapter: 8,
    verse: 28,
    text: 'And we know that all things work together for good to them that love God, to them who are the called according to his purpose.',
    translation: 'KJV'
  },
  {
    id: '5',
    book: 'Philippians',
    chapter: 4,
    verse: 13,
    text: 'I can do all things through Christ which strengtheneth me.',
    translation: 'KJV'
  }
];

export const mockTranslations = [
  // English (self-hosted, public-domain / open-licensed only)
  { id: 'kjv', name: 'King James Version', abbr: 'KJV', language: 'English' },
  { id: 'bsb', name: 'Berean Standard Bible (Modern)', abbr: 'BSB', language: 'English' },
  { id: 'net', name: 'NET Bible (Modern)', abbr: 'NET', language: 'English' },
  { id: 'fbv', name: 'Free Bible Version (Modern)', abbr: 'FBV', language: 'English' },
  { id: 'web', name: 'World English Bible', abbr: 'WEB', language: 'English' },
  { id: 'bbe', name: 'Bible in Basic English', abbr: 'BBE', language: 'English' },
  { id: 'dby', name: 'Darby Translation', abbr: 'DBY', language: 'English' },
  { id: 'wbs', name: "Webster's Bible", abbr: 'WBS', language: 'English' },
  { id: 'acv', name: 'A Conservative Version', abbr: 'ACV', language: 'English' },
  { id: 'roth', name: 'Rotherham (Emphasized)', abbr: 'ROTH', language: 'English' },
  { id: 'jps', name: 'JPS 1917 (Old Testament)', abbr: 'JPS', language: 'English' },
  { id: 'wey', name: 'Weymouth (New Testament)', abbr: 'WEY', language: 'English' },
  { id: 'nheb', name: 'New Heart English Bible', abbr: 'NHEB', language: 'English' },
  { id: 'wesley', name: "Wesley's New Testament", abbr: 'WESLEY', language: 'English' },
  { id: 'lee', name: 'Leeser Bible (Old Testament)', abbr: 'LEE', language: 'English' },
  { id: 'wyc', name: 'Wycliffe Bible (1382)', abbr: 'WYC', language: 'English' },
  { id: 'tyn', name: 'Tyndale Bible (NT + Pentateuch)', abbr: 'TYN', language: 'English' },
  // Spanish (self-hosted, public-domain / open-licensed only)
  { id: 'rvr1960', name: 'Reina-Valera 1960 (con licencia → muestra RVG)', abbr: 'RVR1960', language: 'Español' },
  { id: 'rvg', name: 'Reina-Valera Gómez — similar a RVR1960 (libre)', abbr: 'RVG', language: 'Español' },
  { id: 'rvr1909', name: 'Reina-Valera 1909 (Biblia del Oso)', abbr: 'RVR1909', language: 'Español' },
  { id: 'onbv', name: 'Nueva Biblia Viva — moderna (≈ DHH)', abbr: 'ONBV', language: 'Español' },
  { id: 'ess', name: 'Español Sencillo — lenguaje actual (≈ TLA)', abbr: 'ESS', language: 'Español' },
  { id: 'pdpt', name: 'Palabra de Dios para ti — moderna', abbr: 'PDPT', language: 'Español' },
  { id: 'blm', name: 'Santa Biblia Libre para el Mundo — moderna', abbr: 'BLM', language: 'Español' },
  { id: 'vbl', name: 'Versión Biblia Libre — lenguaje actual', abbr: 'VBL', language: 'Español' },
  { id: 'bll', name: 'Santa Biblia Libre Latinoamericana', abbr: 'BLL', language: 'Español' },
  { id: 'jun', name: 'Jünemann — Biblia católica (Septuaginta, 73 libros)', abbr: 'JUN', language: 'Español' },
  { id: 'rv1602', name: 'Valera 1602 — Biblia del Cántaro (original)', abbr: 'RV1602', language: 'Español' },
  { id: 'rv1569', name: 'Reina 1569 — Biblia del Oso (original)', abbr: 'RV1569', language: 'Español' },
  { id: 'ta', name: 'Torres Amat 1823 — Biblia católica (73 libros)', abbr: 'TA', language: 'Español' },
  { id: 'rv1865', name: 'Reina-Valera 1865 (Valera 1602 revisada)', abbr: 'RV1865', language: 'Español' },
];

export const mockBooks = [
  'Genesis', 'Exodus', 'Leviticus', 'Numbers', 'Deuteronomy',
  'Joshua', 'Judges', 'Ruth', '1 Samuel', '2 Samuel',
  '1 Kings', '2 Kings', '1 Chronicles', '2 Chronicles', 'Ezra',
  'Nehemiah', 'Esther', 'Job', 'Psalm', 'Proverbs',
  'Ecclesiastes', 'Song of Solomon', 'Isaiah', 'Jeremiah', 'Lamentations',
  'Ezekiel', 'Daniel', 'Hosea', 'Joel', 'Amos',
  'Obadiah', 'Jonah', 'Micah', 'Nahum', 'Habakkuk',
  'Zephaniah', 'Haggai', 'Zechariah', 'Malachi',
  'Matthew', 'Mark', 'Luke', 'John', 'Acts',
  'Romans', '1 Corinthians', '2 Corinthians', 'Galatians', 'Ephesians',
  'Philippians', 'Colossians', '1 Thessalonians', '2 Thessalonians', '1 Timothy',
  '2 Timothy', 'Titus', 'Philemon', 'Hebrews', 'James',
  '1 Peter', '2 Peter', '1 John', '2 John', '3 John',
  'Jude', 'Revelation'
];

export const mockSearchResults = [
  {
    reference: 'John 3:16',
    text: 'For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life.',
    book: 'John',
    chapter: 3,
    verse: 16
  },
  {
    reference: '1 John 4:8',
    text: 'He that loveth not knoweth not God; for God is love.',
    book: '1 John',
    chapter: 4,
    verse: 8
  },
  {
    reference: 'Romans 5:8',
    text: 'But God commendeth his love toward us, in that, while we were yet sinners, Christ died for us.',
    book: 'Romans',
    chapter: 5,
    verse: 8
  }
];

export const mockAIResponse = {
  interpretation: 'This verse speaks to the profound nature of God\'s love for humanity. The phrase "God so loved the world" emphasizes the universal scope of divine love, extending to all people regardless of their background or circumstances. The giving of His "only begotten Son" represents the ultimate sacrifice, demonstrating that God\'s love is not merely emotional but actively redemptive.',
  relatedVerses: [
    { reference: 'Romans 5:8', text: 'But God commendeth his love toward us...' },
    { reference: '1 John 4:9', text: 'In this was manifested the love of God...' },
    { reference: 'John 1:14', text: 'And the Word was made flesh...' }
  ],
  themes: ['Love', 'Salvation', 'Sacrifice', 'Eternal Life']
};

export const mockParallelVerses = [
  {
    translation: 'KJV',
    text: 'For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life.'
  },
  {
    translation: 'ESV',
    text: 'For God so loved the world, that he gave his only Son, that whoever believes in him should not perish but have eternal life.'
  },
  {
    translation: 'NIV',
    text: 'For God so loved the world that he gave his one and only Son, that whoever believes in him shall not perish but have eternal life.'
  },
  {
    translation: 'NLT',
    text: 'For this is how God loved the world: He gave his one and only Son, so that everyone who believes in him will not perish but have eternal life.'
  }
];
